export default __webpack_public_path__ + "static/media/chats_large.dbbeef06.png";